export const LOCAL_STORAGE_KEYS = {
  SIGN_UP_VALUES: 'SIGN_UP_VALUES',
  TOKEN: 'access_token',
  USER: 'user',
  SYMPTOM_RECOMMENDATIONS: 'symptom_recommendations',
};
